import Fe from '../ui/FormElement';
export default [
    Fe.Text("name", "Name", "main"),
    Fe.Textarea("description", "Description", "main"),
    Fe.Select("meal_style_id","Meal Style","primary","","name","mealStyles"),
    Fe.Checkbox("is_special", "Special", "primary"),
    Fe.Text("rep_group", "Replacement Group", "primary 2","Optional. Use this to limit replacement of similar meals to only the closest meal in this group."),
]
